import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'font-awesome/css/font-awesome.min.css';
import 'typeface-roboto';
import App from './App';
import './views/core/ToastPage.js';
import './views/core/LoggedOutPrompt.js';
import './views/core/ErrorPrompt.js';
//import './util/IcePieTracker.js';
//import './vendors/FbCampaignTrack.js';
import './vendors/LumosHeartBeat.js';
import './vendors/FreshChatWidget.js';

try{
	window.showConsole = false;
}catch(e){}
 if(console && !window.showConsole){
	var CONSOLE_MODES_ALLOWED = ["error","warn"];
		
	for(var i in console){
		if(CONSOLE_MODES_ALLOWED.indexOf(i) < 0){
			console[i] = () => {};	
		}
	}
} 

ReactDOM.render(<App />, document.getElementById('root'));


try{
	window.alert = console.warn || function(){};
}catch(e){}

/*if(window && window.isSWCacheEnabled){
	registerServiceWorker();
}*/

//To unregister serviceWorker
try{
	if(navigator.serviceWorker){
		navigator.serviceWorker.ready.then(registration => {registration.unregister();});	
	}	
}catch(e){}


// WEBPACK FOOTER //
// ./src/index.js